import React from 'react';
import { useMutation, useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { NOJOOM_ENROLL_SERVICE } from '../../services/common/endpoints';
import { GetCacheKey } from '../../services/common/utils';
import { callQueryapi } from '../../services/http/callapi';
import Loadingcomponent from '../loader/loadingcomponent';
import { setRefetchNojoomPage } from '../../reducer/nojoomSlice';

const NojoomEnrollNow = ({ psmItem }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { data: { data } = {}, isLoading } = useQuery(
    [
      GetCacheKey(psmItem?.uniqueid),
      psmItem?.method,
      JSON.parse(psmItem?.sourceid),
      {},
    ],
    {
      retry: false,
      retryOnMount: false,
    }
  );

  const nojoomEnroll = useMutation(
    (req) =>
      callQueryapi({
        queryKey: [{}, NOJOOM_ENROLL_SERVICE, {}],
      }),
    {
      onSuccess: (udata) => {
        if (udata?.data?.status === '0') {
          dispatch(setRefetchNojoomPage(true));
        }
      },
    }
  );

  const handleEnroll = () => {
    nojoomEnroll.mutate();
  };

  if (isLoading) {
    return <Loadingcomponent />;
  }

  return (
    // <section class="app_main_wrapper d-flex flex-column position_relative">
    //   <div class="center_section">
    //     <div class="sec_top">
    //       <div class="div-height dark_gray_color2">
    //         <div class="full-banner-img"></div>
    //         <div>
    //           <div class="app_alerts_wrap mt-4 pse_sm">
    //             <div class="profile_info">
    //               <div class="profile_info_img">
    //                 <img
    //                   src={process.env.PUBLIC_URL + '/assets/images/user.png'}
    //                   alt=""
    //                   title=""
    //                 />
    //               </div>
    //               <div class="profile_info_desc mb-3">
    //                 <h3 class="message section_title mb-0 text-ellipsis">
    //                   Good morning,
    //                 </h3>
    //                 <h1 class="profile_name text-ellipsis">Raffi</h1>
    //                 <div class="mt-2 nojoom_header_status d-flex align-items-center">
    //                   <img
    //                     src={
    //                       process.env.PUBLIC_URL +
    //                       '/assets/images/nojoom_star_selected_red.svg'
    //                     }
    //                     alt=""
    //                     title=""
    //                   />
    //                   <label class="ms-1">Red</label>
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //           <div class="pse_sm banner-bg-gray-h240">
    //             <div>
    //               <div class="nojoom_points_overview mb-4 -mt-24 nojoom_points_bg">
    //                 <div class="d-flex align-items-center justify-content-between">
    //                   <div class="text-center mb-3 digsub-banner-img">
    //                     <img
    //                       src={
    //                         process.env.PUBLIC_URL +
    //                         '/assets/images/xpress_profit_load_home.png'
    //                       }
    //                       alt=""
    //                       title=""
    //                     />
    //                   </div>
    //                 </div>
    //                 <div class="z-3">
    //                   <button class="custom_btn custom_btn_primary_outline btn_block">
    //                     Enroll Now
    //                   </button>
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </section>
    <div className="pse_sm" onClick={handleEnroll}>
    {/* removed this class for extra border "nojoom_points_overview" */}
    <div class="mb-4 nojoom_points_bg">
        <div class="d-flex align-items-center justify-content-between">
          <div class="text-center mb-3 digsub-banner-img">
            <img
              src={
                data?.response[0]?.banners[0]?.path ||
                process.env.PUBLIC_URL +
                  '/assets/images/xpress_profit_load_home.png'
              }
              alt=""
              title=""
            />
          </div>
        </div>
        {/* <div class="z-3">
          <button
            class="custom_btn custom_btn_primary_outline btn_block"
            onClick={handleEnroll}
            disabled={nojoomEnroll.isLoading}
          >
            {nojoomEnroll.isLoading ? <Loadingcomponent /> : t('enroll_now')}
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default NojoomEnrollNow;
